import { useMutation, useQueryClient } from "@tanstack/react-query";
import { capitalize } from "lodash";
import { NotificationsLevel } from "../../../../../lib/enums";
import { show } from "../../../../../notifications/notifications";
import {
  ErrorResponse,
  MessageErrorResponse
} from "../../../../../requests/@types";
import api from "../../../api";
import { CreateLayoutPayload } from "../@types";
import { GET_LAYOUTS_QUERY_KEY } from "./useGetLayouts";
import useNavigationBlockContext from "./useNavigationBlockContext";

const createLayout = (payload: CreateLayoutPayload) =>
  api.createLayout(payload).then(({ data }) => data);

const useCreateLayout = () => {
  const queryClient = useQueryClient();

  const { api: blockApi } = useNavigationBlockContext();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: createLayout,
    onMutate: () => {
      blockApi.reset();
    },
    onSuccess: (_, { name }) => {
      queryClient.refetchQueries({ queryKey: GET_LAYOUTS_QUERY_KEY });
      show({
        level: NotificationsLevel.SUCCESS,
        message: `Layout: ${name} was succesfully created!`
      });
    },
    onError: ({
      data
    }: ErrorResponse<MessageErrorResponse | Record<string, Array<string>>>) => {
      const msg = data?.message ?? Object.values(data).flatMap(capitalize);
      if (msg) {
        show({
          level: NotificationsLevel.ERROR,
          message: msg
        });
      } else {
        show({
          level: NotificationsLevel.ERROR,
          message: `Failed to create layout!`
        });
      }
    }
  });

  return { create: mutateAsync, isPending };
};

export default useCreateLayout;
